import { useCallback, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useMount } from '.';
import { getLang } from '../utils/lang-utils';

export default function useLanguageSelector() {
  const search = useLocation().search;
  const query = new URLSearchParams(search);
  let systemLanguage = query.get('lang');
  const langData = getLang(systemLanguage || 'en');

  return langData;
}
